import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineExclamationCircle, AiOutlinePrinter } from "react-icons/ai";

// import Pagination from "../../components/Pagination";
import NoData from "../../components/Nodata";

import api from "../../services/api";

import useStore from "../../store";

export default function List() {
  const [customers, setCustomers] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [filters, setFilters] = useState({ search: "" });

  const { user } = useStore();
  const navigate = useNavigate();

  useEffect(() => {
    getCustomers();
  }, [filters]);

  const getCustomers = async (e) => {
    try {
      if (user.role !== "admin") filters.assignee = user.username;
      const { data } = await api.post("customer/search", filters);
      setCustomers(data.customers);
      setTotal(data.total);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= total) {
      setCurrentPage(newPage);
    }
  };

  if (!customers) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="p-5">
      <div className="flex justify-between items-center print:mb-5">
        <h1 className="text-3xl font-bold">Customers</h1>
        <div className="flex items-center space-x-3">
          <button
            title="Print all payments"
            onClick={() => window.print()}
            className="print:hidden cursor-pointer bg-orange-500 hover:bg-orange-700 text-white p-2.5 rounded flex items-center disabled:cursor-progress"
          >
            <AiOutlinePrinter className="text-xl mr-2" />
            <span className="text-sm">Print</span>
          </button>
          <Link
            to="/customer/create"
            className="bg-black hover:bg-gray-700 text-white py-2 px-4 rounded print:hidden"
          >
            Create new customer
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 my-4 print:hidden">
        <input
          type="search"
          placeholder="Search by name or passport"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          className="block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          required
        />
        <select
          className="block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          value={filters.category}
          onChange={(e) => setFilters({ ...filters, category: e.target.value })}
        >
          <option value="">All Categories</option>
          <option value="STUDY">Study Visa</option>
          <option value="VISIT">Visit Visa</option>
          <option value="OTHER">Other</option>
        </select>
        <select
          className="block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          value={filters.payment_status}
          onChange={(e) =>
            setFilters({ ...filters, payment_status: e.target.value })
          }
        >
          <option value="">All Payments statuses</option>
          <option value="DONE">Payments are Cleared</option>
          <option value="PENDING">Payments are Pending</option>
        </select>
      </div>

      <div className="bg-white shadow-lg rounded-lg p-6 print:shadow-none print:rounded-none print:p-0">
        <table className="w-full text-left border-collapse mb-5">
          <thead className="text-sm text-gray-400 border-b">
            <tr>
              <th className="py-2">ID</th>
              <th className="py-2">Name</th>
              <th className="py-2">Category</th>
              <th className="py-2">Passport</th>
              <th className="py-2">Phone</th>
              <th className="py-2">Payment</th>
              <th className="py-2">Assignee</th>
              <th className="py-2 whitespace-nowrap">Created By</th>
            </tr>
          </thead>
          <tbody className="text-sm print:whitespace-nowrap">
            {customers.map((customer) => (
              <tr
                className="hover:bg-gray-50 cursor-pointer border-b"
                onClick={() => navigate(`/customer/${customer.id}`)}
              >
                <td className="p-2 pl-0 py-3">{customer.id}</td>
                <td className="p-2 py-3 uppercase">{customer.name}</td>
                <td className="p-2 py-3">{customer.category || "-"}</td>
                <td className="p-2 py-3">
                  <div>{customer.passport || "-"}</div>
                  <div className="text-xs text-gray-400 pt-2">
                    <p>issue: {customer.passport_issue_at}</p>
                    <p>expiry: {customer.passport_expiry_at}</p>
                  </div>
                  <Expiring expiryDate={customer?.passport_expiry_at} />
                </td>
                <td className="p-2 py-3">{customer.phone}</td>
                <td className="p-2 py-3 text-gray-600">
                  <div className="text-xs pt-2">
                    <p className="flex items-center justify-between">
                      Total:{" "}
                      <strong>
                        {(customer.total_amount || 0).toLocaleString()}{" "}
                        <span className="font-normal">PKR</span>
                      </strong>
                    </p>
                    <p className="flex items-center justify-between">
                      Paid:{" "}
                      <strong>
                        {(customer.paid_amount || 0).toLocaleString()}{" "}
                        <span className="font-normal">PKR</span>
                      </strong>
                    </p>
                    <p className="flex items-center justify-between">
                      Balance:{" "}
                      <strong>
                        {(
                          customer.total_amount - customer.paid_amount || 0
                        ).toLocaleString()}{" "}
                        <span className="font-normal">PKR</span>
                      </strong>{" "}
                    </p>
                    {/* <p className="flex items-center justify-between">
                      Expense:{" "}
                      <strong>
                        {customer.expense || 0}{" "}
                        <span className="font-normal">PKR</span>
                      </strong>
                    </p>
                    <p className="flex items-center justify-between">
                      Net profit:{" "}
                      <strong>
                        {(
                          customer.total_amount -
                            customer.paid_amount -
                            customer.expense || 0
                        ).toLocaleString()}{" "}
                        <span className="font-normal">PKR</span>
                      </strong>{" "}
                    </p> */}
                  </div>
                </td>

                <td className="p-2 py-3">{customer.assignee || "admin"}</td>
                <td className="p-2 py-3">{customer.created_by || "admin"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* 
        <Pagination
          currentPage={currentPage}
          totalPages={total}
          onPageChange={handlePageChange}
        /> */}
        {!customers?.length && <NoData />}
      </div>
    </div>
  );
}

const Expiring = ({ expiryDate }) => {
  if (!expiryDate) return;
  // Current date
  const currentDate = new Date();

  // Calculate the target date after '9'
  const targetDate = new Date();
  targetDate.setMonth(currentDate.getMonth() + 9);

  // Convert expiryDate to a Date object if it's a string
  const expiry = new Date(expiryDate);

  // Check if expiry date is within the target range

  if (expiry <= currentDate) {
    return (
      <p className="text-red-600 text-xs pt-2 flex items-center font-bold">
        <AiOutlineExclamationCircle className="text-base mr-1" />
        Passport Expired
      </p>
    );
  }

  if (expiry <= targetDate)
    return (
      <p className="text-red-600 text-xs pt-2 flex items-center font-bold">
        <AiOutlineExclamationCircle className="text-base mr-1" />
        Passport about to expire
      </p>
    );

  return <></>;
};
